import { useEffect } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { UDS_CONFIG_UPDATE_REQUEST } from '../constants/events.js';
var useUDSUpdate = _ref => {
  let {
    paymentsInfo,
    config,
    esntialDeepLink = {}
  } = _ref;
  const {
    paymentOption,
    creditType,
    interestRate,
    loanTerm,
    downPayment,
    downPaymentPercent,
    leaseTerm,
    leaseMileageRange,
    interactions: {
      hasUpdatedWallet = false,
      paymentEmphasis = false,
      hasOpenedWallet = false
    },
    tradeIn = {},
    zip
  } = paymentsInfo;
  const isWalletActive = hasUpdatedWallet || paymentEmphasis || hasOpenedWallet;
  const isEsntial = Object.keys(esntialDeepLink).length > 0; // fyc has an eligibility check which is a delayed execution hence we need to update config.
  const {
    value: tradeInValue = 0,
    amountOwed = 0
  } = tradeIn;
  useEffect(() => {
    if ((isWalletActive || isEsntial) && Object.keys(paymentsInfo).length && Object.keys(config).length) {
      eventBus.emit(UDS_CONFIG_UPDATE_REQUEST, {
        payments: paymentsInfo,
        config: {
          ...config,
          ...(isEsntial && {
            esntialDeepLink
          })
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentOption, creditType, interestRate, loanTerm, downPayment, downPaymentPercent, leaseTerm, leaseMileageRange, isWalletActive, tradeInValue, amountOwed, zip, isEsntial]);
  return null;
};
export { useUDSUpdate as default };
